/** Stage 2 with verify=true: at least one positive and one negative example file per rubric criterion (any file type, up to MAX_FILES_PER_SLOT each). */
import type { FileItem, RubricCriterion } from '@/lib/types'
import { FileDrop, MAX_FILES_PER_SLOT } from './FileDrop'
import { FileList } from './FileList'

interface Props { taskId: string; rubric: RubricCriterion[]; files: FileItem[]; editable: boolean; onChanged: () => void; onBusy?: (busy: boolean) => void }

export function ExamplesPanel({ taskId, rubric, files, editable, onChanged, onBusy }: Props) {
  const of = (cid: string, kind: 'example_positive' | 'example_negative') => files.filter((f) => f.criterion_id === cid && f.kind === kind)
  const ok = (l: FileItem[]) => l.some((f) => f.status === 'uploaded')
  return (
    <div>
      {rubric.map((c) => (
        <div className="package" key={c.criterion_id}>
          <div className="head"><div><span className="id">{c.criterion_id}</span> <strong>{c.criterion}</strong>{c.evidence && <div className="muted small">Check: {c.evidence}</div>}</div></div>
          <div className="upload-slots">
            {(['example_positive', 'example_negative'] as const).map((kind) => {
              const list = of(c.criterion_id, kind)
              const positive = kind === 'example_positive'
              return (
                <div key={kind} className="upload-slot">
                  <div className="head"><span>{positive ? 'Clearly meets it' : 'Clearly fails it'}</span>{ok(list) ? <span className="chip ok">uploaded</span> : <span className="chip warn">missing</span>}</div>
                  <FileList files={list} canDelete={editable} onChanged={onChanged} />
                  {editable && list.length < MAX_FILES_PER_SLOT && <FileDrop taskId={taskId} meta={{ kind, criterion_id: c.criterion_id }} label={positive ? 'Upload a passing result' : 'Upload a failing result'} hint={positive ? 'A result that meets this criterion' : 'Same result with only this criterion broken'} remaining={MAX_FILES_PER_SLOT - list.length} onUploaded={() => {}} onSettled={onChanged} onBusy={onBusy} />}
                  {editable && list.length >= MAX_FILES_PER_SLOT && <p className="muted small">This slot is full ({MAX_FILES_PER_SLOT} files). Remove one to upload another.</p>}
                </div>
              )
            })}
          </div>
        </div>
      ))}
    </div>
  )
}
